import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip, Typography } from '@mui/material';
import { forwardRef } from 'react';
export const PentairAttribute = forwardRef(({ label, value, color = 'silverGray', tooltip, defaultValue = '-', ...props }, ref) => {
    const element = (_jsxs(Box, { ref: ref, ...props, color: color === 'inherit' ? 'inherit' : `${color}.main`, display: props.display || 'inline-block', children: [_jsx(Typography, { variant: 'body2', color: "inherit", children: _jsx("strong", { children: label }) }), _jsx(Typography, { variant: 'body2', color: "inherit", sx: { opacity: 0.85 }, children: value || defaultValue })] }));
    if (tooltip) {
        return (_jsx(Tooltip, { title: tooltip, placement: "top", children: element }));
    }
    return element;
});
